"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddOrderRating = void 0;
class AddOrderRating {
    constructor(orderRepository) {
        this.orderRepository = orderRepository;
    }
    execute(request) {
        return this.orderRepository.addOrderRating(request);
    }
}
exports.AddOrderRating = AddOrderRating;
